import { render, staticRenderFns } from "./WebTabWidgetContent.vue?vue&type=template&id=7e272e17&scoped=true"
import script from "./WebTabWidgetContent.vue?vue&type=script&lang=js"
export * from "./WebTabWidgetContent.vue?vue&type=script&lang=js"
import style0 from "./WebTabWidgetContent.vue?vue&type=style&index=0&id=7e272e17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e272e17",
  null
  
)

export default component.exports